<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>

    <!-- banner -->
    <!-- <div class="banner">
      <img src="../../assets//img/bg.png">
    </div> -->

    <div style="padding-top: 40px;">
      <div class="main-con" style="margin-bottom: 40px;">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item>{{item.certName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 卡片 -->
        <div class="authentication">
          <p>{{ item.certName }}</p>
          <div v-html="item.certDetail"></div>
        </div>
      </div>
    </div>
    


    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import {certInfo} from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      id:'',
      item:{}
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.certInfo();
  },

  methods:{
     // 获取认证详情
     async certInfo(){
      await certInfo({certId:this.id}).then(res => {
        console.log('我的证书详情',res);
        this.item = res.data;
      })
      .catch(err => {
        
      })
    }
  }
}
</script>
<style scoped>
  .banner{
    width: 100%;
    height: 400px;
  }
  .banner img{
    width: 100%;
    height: 100%;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .authentication{
    /* display: flex;
    align-items: center; */
    /* justify-content: space-between; */
    margin-top: 50px;
  }
  .authentication p{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    border-bottom: 1px solid #E5E5E5;
    padding-bottom: 12px;
  }
  .authentication div{
    margin-top: 20px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 12px;
    color: #666666;
  }
  
</style>



// WEBPACK FOOTER //
// src/views/index/certificationDetails.vue